import ShowMoreToggler from './components/DynamicIssueTypes/ShowMoreToggler';

const ShowMoreEntitiesItem = ({ showMore, isShowMore }) => {
  if (!isShowMore) return null;

  return <ShowMoreToggler showMore={showMore} isShowMore={isShowMore} />;
};

export default ShowMoreEntitiesItem;
